import { exists, MarcTag, MarcTagFromJSON } from '@/api'

export interface MarcLabel {
  tagGroup: string
  labelName: string
  repeat: boolean
  tabPage: number
  tabSimple: boolean
  menuDisplay: number
  displayOrder1: number
  displayOrder2: number
  tags: MarcTag[]
}

export function MarcLabelFromJSON(json: any): MarcLabel {
  return {
    tagGroup: exists(json, 'tag_group') ? json.tag_group : '',
    labelName: exists(json, 'label_name') ? json.label_name : '',
    repeat: exists(json, 'repeat') ? json.repeat : false,
    tabPage: exists(json, 'tab_page') ? json.tab_page : 0,
    tabSimple: exists(json, 'tab_simple') ? json.tab_simple : false,
    menuDisplay: exists(json, 'menu_display') ? json.menu_display : 1,
    displayOrder1: exists(json, 'display_order1') ? json.display_order1 : 1,
    displayOrder2: exists(json, 'display_order2') ? json.display_order2 : 1,
    tags: json.tags.map(MarcTagFromJSON)
  }
}
